import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import noImage from "../../images/no-image.jpg";
import { Bearer_Token } from "../../constants/apiConstants";
import searchIcon from "../../images/search-icon.svg";
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as Loader } from '../../images/loader.svg'

function Index() {
  const [brokersItem, setBrokersItem] = useState([]);
  const [brokerArray, setBrokerArray] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const RESULTS_PER_Page = 20;
  const [skip, setSkip] = useState(0);
  const [visibleLoadButton, setVisibleLoadButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const getBrokers = (e) => {
    axios
      .get(API_BASE_URL + `get/brokers?_skip=0&_limit=100`, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then(function (response) {
        setBrokersItem(response.data.data.brokerData);
        setBrokerArray(response.data.data.brokerData);
        setSkip(response.data.data.brokerData.length);
        axios
        .get(
          API_BASE_URL + `get/brokers?_skip=-1`,
          {
            headers: {
              Authorization: `Bearer ${Bearer_Token}`,
            },
          }
        )
        .then((response) => {
          setBrokerList(response.data.data.allData);
        })
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearchClick = (e) => {
    const searchTerm = e.target.value;
    if(searchTerm.length > 2){
        const filteredItems = brokerList.filter((item) => {
            return (
                item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ||
                item.broker_number.toLowerCase().indexOf(searchTerm) >= 0 || 
                item.user_name.toLowerCase().indexOf(searchTerm) >= 0
            )
        }
      );
      setBrokersItem(filteredItems);
      setVisibleLoadButton(false);
    }else{
      setBrokersItem(brokerArray);
      setVisibleLoadButton(true);
    }
  };

  const loadMoreOnClick = () => {
    setIsLoading(true);
    axios
      .get(
        API_BASE_URL +
          `get/brokers?_skip=${skip}&_limit=${RESULTS_PER_Page}`,
        {
          headers: {
            Authorization: `Bearer ${Bearer_Token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.data.length === 0) {
          setVisibleLoadButton(false);
        }
        setBrokersItem((brokers) => [...brokers, ...response.data.data]);
        //setBrokerList((brokers) => [...brokers, ...response.data.data]);
        setBrokerArray((brokers) => [...brokers, ...response.data.data]);
        setSkip(skip + response.data.data.length);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  useEffect(() => {
    getBrokers();
  }, []);

  return (
    <>
    <ToastContainer />
      <section class="grid_box">
        <div class="container">
          <div className="row align-items-center text_he_box">
            <div className="col-md-4">
              <h4>Brokers</h4>
            </div>
            <div className="col-md-4">
              <div class="searchbox d-flex">
                <input
                  class="form-control"
                  placeholder="Search Brokers"
                  type="text"
                  onChange={handleSearchClick}
                />
                <button type="button">
                  <img
                    alt="search-icon"
                    src={searchIcon}
                  />
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <h4 className="property-title text-end">Verified Brokers</h4>
            </div>
          </div>
        </div>
      </section>

      <section class="developers_box">
        <div class="container">
          <div class="grid_dev">
            <div class="row row-cols-3">
              {brokersItem && brokersItem.map((element) => (
                <div class="custom-col-2 text-center">
                  {element.profile_picture ? (
                    <div class="new_box_img3">
                      {element.profile_picture.includes("https") ? (
                        <img
                          src={element.profile_picture}
                          width="78px"
                          height="78px"
                          alt=""
                        />
                      ) : (
                        <img
                          src={
                            ASSETS_URL +
                            "broker/profile/" +
                            element.profile_picture
                          }
                          width="78px"
                          height="78px"
                          alt=""
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <img src={noImage} width="78px" height="78px" alt="" />
                    </div>
                  )}
                  <div className="broker_name">{element.name}</div>
                  <div className="broker_username">{element.user_name}</div>
                  <div className="broker_number">{element.broker_number}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      
      {visibleLoadButton && (
        <div className="button_showmore button_showmore_developer text-center">
          {isLoading ? (
            <a href="#!"><Loader className="login-spinner" /></a>
          ) : (
            <a href="#!" onClick={loadMoreOnClick}> Show More </a>
          )}
        </div>
      )}
    </>
  );
}

export default Index;
